import BaseService from "src/packages/BaseService";

export default class MeasurementService extends BaseService {
	static get className() {
		return "measurement";
	}

	static async duplicate(id, form) {
		let response = await BaseService.getService().post("measurement/duplicate/" + id, form);
		return response.data;
	}

	static async done(form) {
		let response = await BaseService.getService().post("measurements/done", form);
		return response.data;
	}

	static async cancel(form) {
		let response = await BaseService.getService().post("measurements/cancel", form);
		return response.data;
	}

	static async reCalculate(params) {
		let response = await BaseService.getService().get("calculate/measurement", {params});
		return response.data;
	}

	static async download(params) {
		let response = await BaseService.getService().get("measurement/download", {params});
		return response.data;
	}

	static async downloadFtpDirectory(id) {
		return BaseService.getService().get(`measurement/${id}/ftp-directory-download`, {
			responseType: "blob"
		});
	}

	static async multiUpdate(form) {
		let response = await BaseService.getService().post("measurements/multi", form);
		return response.data;
	}

  static async renew(id, form) {
		let response = await BaseService.getService().post("measurement/renew/" + id, form);
		return response.data;
	}
};
